import { jwtDecode, type JwtPayload } from "jwt-decode";

import { isFalsy } from "@vega-core/utils/isFalsy";

export function checkIfTokenExpired(token: string) {
  if (token === "") {
    return false;
  }

  try {
    const tokenPayload: JwtPayload = jwtDecode(token);

    if (isFalsy(tokenPayload.exp)) return true;

    const currentTime = Date.now() / 1000;

    return tokenPayload.exp < currentTime;
  } catch (error) {
    console.error("Error parsing token:", error);

    return true;
  }
}
